// extracted by mini-css-extract-plugin
export default {"successMessage":"dq_l7","thanksText":"dq_l8","detailsText":"dq_l9","twitterIcon":"dq_mb","twitterLink":"dq_mc"};